import ApiService from '../services/ApiService';
import * as types from "./ActionTypes";

const requestGetContacts = identitiesId => ({
    type: types.GET_CONTACTS,
    payload: {
        identitiesId,
    },
});

const getContactsSuccess = contacts => ({
    type: types.GET_CONTACTS_SUCCESS,
    payload: {
        contacts,
    },
});

const getContactsFailure = error => ({
    type: types.GET_CONTACTS_FAILURE,
    error,
});

const getContactDataSuccess = contact => ({
    type: types.GET_CONTACT_DATA_SUCCESS,
    payload: {
        contact,
    },
});

const getContactDataFailure = error => ({
    type: types.GET_CONTACT_DATA_FAILURE,
    payload: {
        error,
    },
});

/**
 * Get user contacts
 */
export const getContacts = () => async (dispatch, getState) => {
    const { identitiesId } = getState().identification;

    dispatch(requestGetContacts(identitiesId));
    try {
        const res = await ApiService.getIdentitiesContacts({ identitiesId });
        dispatch(getContactsSuccess(res.data.data));
    } catch(err) {
        dispatch(getContactsFailure(err.response));
    };
};

/**
 * Get contact data
 * @param {string} identitiesId user identifier
 * @param {string} hashId contact identifier
 */
const getContactData = (identitiesId, hashId) => async (dispatch) => {
    try {
        const res = await ApiService.getContactWayData({ identitiesId, hashId });
        dispatch(getContactDataSuccess(res.data.data));
    } catch (err) {
        dispatch(getContactDataFailure(err.response));
    };
}

/**
 * Get full contacts included non obfuscated data
 */
export const getFullContacts = () => async (dispatch, getState) => {
    const { identitiesId } = getState().identification;
    await dispatch(getContacts(identitiesId));
    const contacts = getState().contacts;

    for (const contact of contacts) {
        await dispatch(getContactData(identitiesId, contact.contactId));
    }
};

